import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {getOrganizationName} from '../selectors/deals';
import * as deals from '../redux/actions/deals';
import {routeNames} from '../constants/routes';

interface IUrlParams {
  a: string;
  r: string;
  oid?: string;
}

const useDiscount = (addInfo?: string) => {
  const [urlParams, setUrlParams] = useState<IUrlParams>({a: '', r: ''});
  const [readyToRedirect, setReadyToRedirect] = useState<boolean>(false);
  const [discountFB, setDiscountFB] = useState<boolean>(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const organizationName = useSelector(getOrganizationName);

  useEffect(() => {
    const params = {} as any;
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }

    const storedParams = localStorage.getItem('redirection');

    if (!addInfo || addInfo !== 'redirectionPage') {
      if (storedParams) setUrlParams(JSON.parse(storedParams));
    } else {
      setUrlParams(params);
    }

    if (storedParams) {
      const storedParamsObj = JSON.parse(storedParams);
      if (storedParamsObj.oid && storedParamsObj.oid === 'FB') {
        setDiscountFB(true);
      }
    }
  }, []);

  useEffect(() => {
    if (
      urlParams.a &&
      urlParams.a.length > 0 &&
      urlParams.oid &&
      !organizationName.data.name &&
      !organizationName.error
    ) {
      if (urlParams.oid === 'FB') {
        setDiscountFB(true);
      } else {
        setDiscountFB(false);
      }

      dispatch(deals.getOrganizationName({oid: urlParams.oid}));
    }
  }, [urlParams]);

  useEffect(() => {
    if (readyToRedirect) {
      if (urlParams.oid) {
        if (urlParams.oid === 'FB') {
          localStorage.setItem('specialOffers', 'fb');
        }

        if (organizationName && organizationName.data) {
          if (organizationName.data.isGivebackMember) {
            dispatch(
              deals.activateGivebackParticipant({partnerId: organizationName.data.partnerId}),
            );
          } else {
            dispatch(deals.activateOneTimeDiscount({partnerId: organizationName.data.partnerId}));
          }
        }
      }

      navigate(routeNames.home, {replace: true});
    }
  }, [readyToRedirect]);

  return {setReadyToRedirect, discountFB};
};

export default useDiscount;
